import type { VoidFunctionComponent } from 'react';
import { useState } from 'react';
import cx from 'classnames';
import * as _ from 'lodash';
import type { BillingTermWithUsageFields } from '../../../../models/types';
import { useAsyncStatus, useOnMount } from '../../../hooks';
import * as api from '../../../redux/api';
import List from '../../generic/List';
import BillingTermRow from './BillingTermRow';
import AddBillingTermForm from './AddBillingTermForm';
import styles from './BillingTermCard.module.less';
import Text from '../../generic/Text';
import ListRowLoading from '../../generic/List/ListRowLoading';
import type { FailedFetchResponse } from '../../../helpers/errors';

export const BILLING_TERM_URL = '/api/organization/billing-terms';

const BillingTermCard: VoidFunctionComponent = () => {
  const { status, onError, onPending, onSuccess } = useAsyncStatus();
  const [billingTerms, setBillingTerms] = useState<BillingTermWithUsageFields[]>([]);

  const fetchBillingTerms = async () => {
    onPending();
    try {
      const billingTermRequestResults = await api.get(BILLING_TERM_URL);
      setBillingTerms(billingTermRequestResults.data as BillingTermWithUsageFields[]);
    } catch (err) {
      onError(err as FailedFetchResponse);
    }
    onSuccess();
  };

  useOnMount(fetchBillingTerms);

  return (
    <div className={cx(styles.billingTermsCard, 'card')}>
      <h3>Manage Billing Terms</h3>
      <Text.H4>Current Billing Terms</Text.H4>
      <List.Body>
        {status.isLoading && _.times(billingTerms.length || 1, () => (<ListRowLoading />))}
        {!status.isLoading &&
          billingTerms.map((billingTerm) => (
            <BillingTermRow billingTerm={billingTerm} onRemove={fetchBillingTerms} />
          ))}
      </List.Body>
      <AddBillingTermForm onTermAdd={fetchBillingTerms} />
    </div>
  );
};

export default BillingTermCard;
